import { render, staticRenderFns } from "./InfoStepConfirmacaoSucesso.vue?vue&type=template&id=3bf8d54d"
import script from "./InfoStepConfirmacaoSucesso.vue?vue&type=script&lang=js"
export * from "./InfoStepConfirmacaoSucesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports